module.exports = __webpack_public_path__ + "assets/img/D1.88b23811.png";